module.exports = __webpack_public_path__ + "img/Hoja_Derecha_optima.4e6fc9d0.svg";